import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./app/App";
import { VenueScopeProvider } from "./app/venueScope";
import { WorkspaceProvider } from "./app/workspace";
import { AuthProvider } from "./auth/AuthProvider";
import "./styles.css";
import { AccountAppearance } from "./theme/accountAppearance";
import { ThemeProvider } from "./theme/ThemeProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 15_000, refetchOnWindowFocus: false, retry: 1 },
    mutations: { retry: false },
  },
});

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("The application root element is missing.");

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            {/* Inside the session and outside the routes. Appearance belongs to the person, so it is
                adopted once for whoever is signed in rather than by whichever page happens to be
                open, and the sign-in page keeps the colors this browser already had. */}
            <AccountAppearance />
            <WorkspaceProvider>
              <VenueScopeProvider>
                <App />
              </VenueScopeProvider>
            </WorkspaceProvider>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
